export class DisabledKeys {
    public Keys = ['Controller0', 'EntityId0', 'Controller1', 'EntityId1', 'Controller2', 'EntityId2', 'Section', 'Method', 'ApiVersion'];
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/DisabledKeys.ts